import { render, staticRenderFns } from "./add-eds.vue?vue&type=template&id=023b4970"
import script from "./add-eds.vue?vue&type=script&lang=js"
export * from "./add-eds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports